export enum EntitiesEnum {
  SCHEDULE = "schedule",
  FACTURACION = "facturacion",
  JUDICIALES = "judiciales",
  PAGOS = "pagos",
  PREJUDICIALES = "prejudiciales",
}
